import Block from '../../../../_base/src/components/block'

export default class HarmonicPageHeader extends Block {
	static title = 'page-header'

	constructor($el) {
		super($el)

		this.logo = this.$el.find('.page-header__inner img')
		this.navLogo = $('.nav-popup--large')

		if (this.logo.length > 0) {
			this.chekcInView()

			$(window).on('scroll', () => {
				this.chekcInView()
			})
		}
	}

	chekcInView() {
		const elTop = this.logo.offset().top
		const elBot = elTop + this.logo.outerHeight()

		const viewportTop = $(window).scrollTop()
		const viewportBot = viewportTop + $(window).height()

		if (elBot > viewportTop && elTop < viewportBot) {
			this.navLogo.removeClass('opacity-100')
			this.navLogo.addClass('opacity-0')
		} else {
			this.navLogo.removeClass('opacity-0')
			this.navLogo.addClass('opacity-100')
		}
	}
}
